export const WEBSITE_PREFILL = "https://";
